import { initializeApp, getApps } from "firebase/app";
import {
  initializeFirestore,
  memoryLocalCache,
  collection,
  addDoc,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
  limit,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyANMKIFT8dIopF0zDrd9IKbJOcP8slRIxY",
  authDomain: "codeuniquely.firebaseapp.com",
  projectId: "codeuniquely",
  storageBucket: "codeuniquely.appspot.com",
  messagingSenderId: "167914923468",
  appId: "1:167914923468:web:564aeee21680ef779c2969",
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Use memory-only cache so addDoc does NOT silently succeed from local cache.
// Writes will only resolve after the server acknowledges them.
const db = initializeFirestore(app, { localCache: memoryLocalCache() });

class FirebaseService {
  static validateHireLead(payload) {
    const requiredFields = ["name", "email", "projectType", "budget", "timeline", "message"];
    for (const field of requiredFields) {
      if (!payload[field] || !String(payload[field]).trim()) {
        throw new Error(`Please fill in the "${field}" field.`);
      }
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      throw new Error("Please enter a valid email address.");
    }
  }

  static async submitHireLead(payload) {
    FirebaseService.validateHireLead(payload);

    const data = {
      name: String(payload.name).trim().slice(0, 100),
      email: String(payload.email).trim().toLowerCase().slice(0, 200),
      projectType: String(payload.projectType).trim().slice(0, 120),
      budget: String(payload.budget || "").trim().slice(0, 120),
      timeline: String(payload.timeline || "").trim().slice(0, 120),
      message: String(payload.message).trim().slice(0, 4000),
      source: "hire-me-modal",
      createdAt: serverTimestamp(),
    };

    const docRef = await addDoc(collection(db, "hire_leads"), data);

    // Wait for the server to confirm the write actually landed.
    // With memory cache this resolves quickly, but gives us a real
    // confirmation rather than a silent local-only write.
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        unsub();
        reject(new Error("Server did not confirm the write. Please try again."));
      }, 15000);

      const unsub = onSnapshot(
        docRef,
        { includeMetadataChanges: true },
        (snap) => {
          if (snap.exists() && !snap.metadata.hasPendingWrites) {
            clearTimeout(timeout);
            unsub();
            resolve();
          }
        },
        (err) => {
          clearTimeout(timeout);
          unsub();
          reject(err);
        }
      );
    });

    return { id: docRef.id };
  }

  static subscribeHireLeads(onData, onError) {
    const leadsQuery = query(
      collection(db, "hire_leads"),
      orderBy("createdAt", "desc"),
      limit(200)
    );

    return onSnapshot(
      leadsQuery,
      (snapshot) => {
        const leads = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        onData(leads);
      },
      (error) => {
        if (onError) onError(error);
      }
    );
  }
}

export default FirebaseService;
